import { CommonCookieBanner } from "#components";

export function useCookieManagement() {
  const { $posthog } = useNuxtApp();

  const cookieBannerLocalStorage = useLocalStorage<string | null>(
    "cookie-consent",
    null
  );

  function checkCookieConsent() {
    if (cookieBannerLocalStorage.value === null) {
      // useModal().open(CommonCookieBanner);
    } else {
      if (usePosthog().isPosthogEnabled()) {
        $posthog().reset();

        if (isCookieConsentGiven()) {
          $posthog()?.set_config({
            persistence: "localStorage+cookie",
          });
        } else {
          $posthog()?.set_config({
            persistence: "memory",
          });
        }

        usePosthog().identifyIfNecessary();
      }
    }
  }

  function isCookieConsentGiven(): boolean {
    return (cookieBannerLocalStorage.value ?? "false") == "true";
  }

  return {
    cookieBannerLocalStorage,
    checkCookieConsent,
    isCookieConsentGiven,
  };
}
